import { render, staticRenderFns } from "./AuctionWinner.vue?vue&type=template&id=3e356b6c&"
import script from "./AuctionWinner.vue?vue&type=script&lang=js&"
export * from "./AuctionWinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports